// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, ServiceResult } from "@insite/client-framework/Services/ApiService";

export const realTimeInvoicePdf = "/api/sainc/realTimeInvoicePdf";
export const realTimeCommercialInvoicePdf = "/api/sainc/realTimeInvoicePdf/commercial";
export const realTimeFtaInvoicePdf = "/api/sainc/realTimeInvoicePdf/fta";

export interface RealTimeInvoiceModel {
    invoiceNumber: string;
}

export async function realTimeInvoice(parameter: {
    invoiceNumber: string;
    isInternational: boolean;
}): Promise<ServiceResult<RealTimeInvoiceModel>> {
    try {
        const realTimeInvoiceModel = parameter.isInternational
            ? await get<RealTimeInvoiceModel>(`${realTimeCommercialInvoicePdf}/${parameter.invoiceNumber}`)
            : await get<RealTimeInvoiceModel>(`${realTimeInvoicePdf}/${parameter.invoiceNumber}`);
        return {
            result: realTimeInvoiceModel,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}
